import React, { useContext, useRef } from 'react';
import type { FC, PropsWithChildren } from 'react';

import { AppContext } from '../capabilities/contextStore/AppContext';
import { SessionOutcome } from '../components/SessionOutcome/SessionOutcome';

export const HostedSessionOutcome: FC<PropsWithChildren> = ({
  children,
}) => {
  const { setData } = useContext(AppContext);
  const stopPollingRef = useRef(false);

  return (
    <SessionOutcome
      shouldStartPolling
      stopPollingRef={stopPollingRef}
      onNewSessionData={(originalCheckoutSessionResponse) => {
        // Allow `AwaitingPaymentMethodContainer` to react to new session data,
        // along with other parts of the app.
        setData({
          originalCheckoutSessionResponse,
        });
      }}
    >
      {children}
    </SessionOutcome>
  );
};
